__turbopack_context__.v({
  "hugeTitle": "Section-module-scss-module__-fCm8W__hugeTitle",
  "section": "Section-module-scss-module__-fCm8W__section",
  "visible": "Section-module-scss-module__-fCm8W__visible",
});
